(function () {
  function cleanLabel(link) {
    return (link.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function normaliseFindATileLinks(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('a[href="/collections/all"], a[href$="/collections/all"]').forEach(function (link) {
      var label = cleanLabel(link);
      if (label === 'find a tile' || label === 'browse tiles') {
        link.setAttribute('href', '/pages/find-a-tile');
      }
    });
  }

  function init(root) {
    normaliseFindATileLinks(root || document);

    if (window.location.pathname === '/collections/all') {
      window.location.replace('/pages/find-a-tile' + window.location.search + window.location.hash);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();

(function () {
  var rootSelector = '#shopify-pc__banner, #shopify-pc__prefs';
  var replacements = [
    ['Learn more about the cookies we use, and choose which cookies to allow.', 'Choose which cookies to allow.'],
    ['Personalization', 'Personalisation'],
    ['personalization', 'personalisation'],
    ['Personalize', 'Personalise'],
    ['personalize', 'personalise'],
    ['Optimize', 'Optimise'],
    ['optimize', 'optimise']
  ];

  function replaceCopy(value) {
    var next = value;
    replacements.forEach(function (pair) {
      next = next.split(pair[0]).join(pair[1]);
    });
    return next;
  }

  function updateText(root) {
    if (!root) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      var next = replaceCopy(node.nodeValue || '');
      if (next !== node.nodeValue) node.nodeValue = next;
    }

    root.querySelectorAll('[aria-label], [title]').forEach(function (element) {
      ['aria-label', 'title'].forEach(function (attribute) {
        var value = element.getAttribute(attribute);
        if (!value) return;
        var next = replaceCopy(value);
        if (next !== value) element.setAttribute(attribute, next);
      });
    });
  }

  function applyCookieCopy() {
    document.querySelectorAll(rootSelector).forEach(updateText);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyCookieCopy);
  } else {
    applyCookieCopy();
  }

  var observer = new MutationObserver(function (mutations) {
    var shouldApply = mutations.some(function (mutation) {
      if (mutation.type === 'characterData') return true;
      return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
        return node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE;
      });
    });
    if (shouldApply) applyCookieCopy();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true
  });
})();
